//高さをそろえる
if($('.js_syncTarget').length){
 
  var myBreakPoint = 840;//ブレイクポイント
  var target = $('.js_syncTarget');//高さをそろえたい要素の親要素
  var target_c;//高さをそろえる要素
  var group_amount;//高さを揃えたいグループの総数
  var maxHeight = 0;//グループ内で最も高い要素を記憶する
 
  function heightSync(target){
 
    target.each(function(){
 
      group_amount = $(this).data('group_amount');
 
      for (var i = 0; i < group_amount; i++) {
 
        maxHeight = 0;
 
        console.log(i);
 
        target_c = $(this).find('.js_syncTarget_c.g' + (i + 1));
        target_c.height('auto');
 
        target_c.each(function(){
          if($(this).height() > maxHeight) {
            maxHeight = $(this).height();
          }
        });
 
        target_c.height(maxHeight);
         
      }
 
    });
 
  }
 
  heightSync(target);
 
  $(window).resize(function(){
    var w = $(window).width();
    if(w > myBreakPoint) {
      heightSync(target);
    } else {
      $('.js_syncTarget_c').height('auto');
    }
     
  });
 
}